import { Ellipsis, X } from "lucide-react";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

export default function TaskFormSkeleton() {
    return (
        <section className="flex flex-col justify-between h-full gap-1.5 bg-white rounded-r-sm">
            <div className="flex items-center gap-2 justify-between p-4 pb-0">
                <div className="flex-1 flex items-start gap-4">
                    <div className="text-lg font-medium text-zinc-500 text-nowrap">
                        <div className="flex items-center gap-4">
                            <Skeleton className="h-3 w-[40px]" />
                            <Skeleton className="h-3 w-[250px]" />
                        </div>
                    </div>
                </div>
                <div className="flex items-top self-start pt-[4px]">
                    <Button disabled={true} variant="ghost" size="icon" className="text-zinc-600 hover:text-zinc-900 hover:bg-neutral-200/70">
                        <Ellipsis className="size-4" />
                    </Button>
                    <Button disabled={true} variant="ghost" size="icon" className="text-zinc-600 hover:bg-neutral-200/70">
                        <X className="size-4" />
                    </Button>
                </div>
            </div>
            <div className="rounded-md bg-white p-4 border border-neutral-200/50 flex-1 pt-5">
                <div className="grid grid-cols-[70px_100px] gap-x-20 gap-y-6 auto-rows-auto">
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-full" />
                </div>
            </div>

            <div className="p-2 flex justify-start gap-4">
                <Skeleton className="h-3 w-[80px]" />
                <Skeleton className="h-3 w-[80px]" />
                <Skeleton className="h-3 w-[80px]" />
            </div>
            <div className="rounded-md pt-3 bg-white p-4 border border-neutral-200/50 flex-1"></div>
        </section>
    );
}
